export const isLoadingDeviceStatus = (state) =>
  state.tabletRegistration?.loading;
